<template>
    <div>
        <buttonlist @help="help" @reflash="reflash" @save="save" ref="SetBtn"></buttonlist>
        <div>
            <table>
                <tr>
                    <td>
                        <el-divider content-position="left">{{$t('getapi[3490]')}}</el-divider>
                    </td>
                </tr>
                <tr>
                    <td>
                        {{$t('getapi[3496]')}}
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-radio v-model="dataDetail.changetype" :label=3>{{$t('getapi[3494]')}}</el-radio>
                        <el-radio v-model="dataDetail.changetype" :label=2>{{$t('getapi[3493]')}}</el-radio>
                        <el-radio v-model="dataDetail.changetype" :label=1>{{$t('getapi[3492]')}}</el-radio>
                    </td>
                </tr>
                <tr>
                    <td>
                        {{$t('getapi[3495]')}}
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-input v-model="dataDetail.rounddigit" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                  style="width:110px"></el-input>
                        位
                    </td>
                </tr>
                <tr>
                    <td>
                        {{$t('getapi[6899]')}}
                        <el-input v-model="dataDetail.amount_limit" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                  style="width:110px"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-divider content-position="left">{{$t('getapi[13481]')}}</el-divider>
                    </td>
                </tr>
                <tr>
                    <td>
                        1.{{$t('getapi[13482]')}}
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-radio v-model="dataDetail.paytype" :label=1>{{$t('getapi[13485]')}}</el-radio>
                        <el-radio v-model="dataDetail.paytype" :label=2>{{$t('getapi[13486]')}}</el-radio>
                    </td>
                </tr>
                <tr>
                    <td>
                        2.{{$t('getapi[13483]')}}
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-radio v-model="dataDetail.receivetype" :label=1>{{$t('getapi[13485]')}}</el-radio>
                        <el-radio v-model="dataDetail.receivetype" :label=2>{{$t('getapi[13486]')}}</el-radio>
                    </td>
                </tr>
                <tr>
                    <td>
                        3.{{$t('getapi[13484]')}}
                    </td>
                </tr>
                <tr>
                    <td>
                        <div style="display: flex">
                            <span style="display: block;min-width:100px">{{$t('getapi[13487]')}}</span>
                            <el-input
                                    v-model="dataDetail.inside_subject_code"
                                    type="text"
                                    readonly
                                    size="mini"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectSubject(1)"></i>
                            </el-input>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div style="display: flex">
                            <span style="display: block;min-width:100px">{{$t('getapi[13488]')}}</span>
                            <el-input
                                    v-model="dataDetail.outside_subject_code"
                                    type="text"
                                    readonly
                                    size="mini"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectSubject(2)"></i>
                            </el-input>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div style="display: flex">
                            <span style="display: block;min-width:100px">{{$t('getapi[13489]')}}</span>
                            <el-input
                                    v-model="dataDetail.other_subject_code"
                                    type="text"
                                    readonly
                                    size="mini"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectSubject(3)"></i>
                            </el-input>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-divider content-position="left">{{$t('getapi[13530]')}}</el-divider>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div style="display: flex">
                            <span style="display: block;min-width:100px">{{$t('getapi[13531]')}}</span>
                            <el-input v-model="dataDetail.pur_price_digit" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                      style="width:110px"
                                      min="1"
                                      max="8"
                                      step="1"
                                      oninput="this.value = this.value.replace(/[^0-9]/g, ''); if(this.value < 1) this.value=1; if(this.value > 8) this.value=8">></el-input>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div style="display: flex">
                            <span style="display: block;min-width:100px">{{$t('getapi[13532]')}}</span>
                            <el-input v-model="dataDetail.sal_price_digit" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                      style="width:110px"
                                      min="1"
                                      max="8"
                                      step="1"
                                      oninput="this.value = this.value.replace(/[^0-9]/g, ''); if(this.value < 1) this.value=1; if(this.value > 8) this.value=8">></el-input>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div style="display: flex">
                            <span style="display: block;min-width:100px">{{$t('getapi[13533]')}}</span>
                            <el-input v-model="dataDetail.pur_amount_digit" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                      style="width:110px"
                                      min="1"
                                      max="6"
                                      step="1"
                                      oninput="this.value = this.value.replace(/[^0-6]/g, ''); if(this.value < 1) this.value=1; if(this.value > 6) this.value=6">></el-input>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div style="display: flex">
                            <span style="display: block;min-width:100px">{{$t('getapi[13534]')}}</span>
                            <el-input v-model="dataDetail.sal_amount_digit" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                      style="width:110px"
                                      min="1"
                                      max="4"
                                      step="1"
                                      oninput="this.value = this.value.replace(/[^0-4]/g, ''); if(this.value < 1) this.value=1; if(this.value > 4) this.value=4">></el-input>
                        </div>
                    </td>
                </tr>
            </table>
        </div>

        <!--选择会计科目-->
        <subjecttable :isVisible="false" :isBatch=false :selectType="0" :isSplitPage="true"
                      :postUrl="'/GL/Basic/GetSubjectPopuDataList'" @callback="getSubject" ref="subject"></subjecttable>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'financeconfig',
        data() {
            return {
                userData: [], // 用户信息
                dataDetail: {},
                subjecttype:1,
            };
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.getView();
            that.authority();
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1124]"),this.$t("getapi[11]"));
            },
            //权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权
                if (that.$limits.ReadOnlyRights('plv2', 210, 1)) {
                    that.$refs.SetBtn.SetButtonEnable('refresh');
                }
                //操作权
                let ilimits = that.$limits.UnOperationAuthority('plv2', 210, 1);
                // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                switch (ilimits) {
                    case 2:
                        that.$refs.SetBtn.SetButtonEnable('save,refresh');
                        break;
                    case 3:
                        that.$refs.SetBtn.SetButtonEnable('save,refresh');
                        break;
                    default:
                        that.$refs.SetBtn.SetButtonEnable('');
                        break;
                }
            },
            getView() {
                let that = this;
                let data = '';
                that.$http.urlpost('/Basic/Finance/GetFinanceSetInfo', data, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            save() {
                let that = this;
                let parm = that.dataDetail;
                that.$http.urlpost('/Basic/Finance/FinanceSetSave', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            selectSubject(type){
                let that = this
                that.subjecttype = type
                that.$refs.subject.clearInput(true);
            },
            getSubject(data){
                let that = this
                console.log(data)
                if(that.subjecttype == 1){
                    that.dataDetail.inside_subject_code = data['科目编码']
                } else if(that.subjecttype == 2){
                    that.dataDetail.outside_subject_code = data['科目编码']
                } else if(that.subjecttype == 3) {
                    that.dataDetail.other_subject_code = data['科目编码']
                }
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
